module.exports = __webpack_public_path__ + "img/1.54f3d917.jpg";